// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.product-bottom-navigation__wrapper{display:flex;flex-direction:column;gap:.75rem;justify-content:flex-start;padding:1.5rem 1rem 1rem}.product-bottom-navigation__wrapper.without-breadcrumbs{justify-content:flex-end}@media(min-width:1024px){.product-bottom-navigation__wrapper{flex-direction:row;justify-content:space-between;padding:1.5rem 1.5rem 1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
